
import { TUser } from "@/features/auth/types";
import { UserAction } from "./user.action";
import userTypes from "./user.types";

interface IUserReducerState {
  userConnected: TUser | null
}

const INITIAL_STATE = {
  userConnected: {
    nom: "",
    prenoms: "",
    profil_id: "",
    email: "",
    telephone : "",
    profil : {},
    token : ""
  }
};

const userReducer = (
  state: IUserReducerState = INITIAL_STATE,
  action: UserAction
): IUserReducerState => {
  switch (action.type) {
    case userTypes.UPDATE_USER_CONNECTE:
      return {
        ...state,
        userConnected: action.payload
      };
    default:
      return state;
  }
};

export default userReducer;
